<template>
  <div class="accordion-container">
    <LoaderWrapper :state="loadState" class="loader-wrapper">
      <div class="accordion-header"
           @click="toggleAccordion">
        <button
          class="accordion-title-button">
          <slot name="title"></slot>
          <span v-if="successNotice"
                class="accordion-success-notice">
            {{ successNotice }}
          </span>
        </button>
        <img v-if="currentTheme === 'light'"
             v-show="!isOpen"
             class="accordion-icon"
             :src="ihuAccordionClosedLT"
             alt="ihuAccordionClosedLT">
        <img v-else
             v-show="!isOpen"
             class="accordion-icon"
             :src="ihuAccordionClosedDT"
             alt="ihuAccordionClosedDT">
        <img v-if="currentTheme === 'light'"
             v-show="isOpen"
             class="accordion-icon"
             :src="ihuAccordionOpenLT"
             alt="ihuAccordionOpenLT">
        <img v-else
             v-show="isOpen"
             class="accordion-icon"
             :src="ihuAccordionOpenDT"
             alt="ihuAccordionOpenDT">
      </div>
      <div
        v-show="isOpen"
        class="accordion-content">
        <slot name="content"></slot>
      </div>
    </LoaderWrapper>
  </div>
</template>

<script>
  import { DATA_STATES } from '@/store/consts';
  import { currentThemeMixin } from '@/mixins';
  import LoaderWrapper from './loader-wrapper';
  import ihuAccordionClosedDT from './../../../assets/img/ihu_accordion_closed_DT.png';
  import ihuAccordionOpenDT from './../../../assets/img/ihu_accordion_open_DT.png';
  import ihuAccordionClosedLT from './../../../assets/img/ihu_accordion_closed_LT.png';
  import ihuAccordionOpenLT from './../../../assets/img/ihu_accordion_open_LT.png';

  export default {
    name: 'ihu-accordion',
    components: {
      LoaderWrapper,
    },
    mixins: [currentThemeMixin],
    props: {
      loadState: {
        type: String,
        default: DATA_STATES.NONE,
      },
      successNotice: {
        type: String,
        required: false,
        default: undefined,
      },
    },
    data() {
      return {
        isOpen: false,
        ihuAccordionClosedDT,
        ihuAccordionOpenDT,
        ihuAccordionClosedLT,
        ihuAccordionOpenLT,
      };
    },
    methods: {
      toggleAccordion() {
        this.isOpen = !this.isOpen;
      },
    },
  };
</script>

<style scoped lang="scss">
  .accordion-container {
    width: 100%;
    height: 100%;
    display: flex;

    border: 1px solid;
    border-radius: 4px;
    @include themify {
      border-color: getColor('ihuAccordionTitleButtonBorderColor', 'ihu');
      background: getColor('ihuAccordionTitleButtonBackgroundColor', 'ihu');
    }
    .loader-wrapper {
      width: 100%;
      .accordion-header {
        display: flex;
        cursor: pointer;
        .accordion-title-button {
          box-sizing: border-box;
          width: 100%;
          height: 64px;
          border-radius: 4px;
          border: 0px;
          cursor: pointer;
          position: relative;

          padding-left: 24px;
          font-weight: 500;
          font-size: 20.16px;
          line-height: 135%;
          display: flex;
          align-items: center;

          @include themify {
            background: getColor('ihuAccordionTitleButtonBackgroundColor', 'ihu');
            color: getColor('ihuAccordionTitleButtonColor', 'ihu');
          }

          .accordion-success-notice {
            align-items: center;
            letter-spacing: 0.01em;
            font-weight: 400;
            font-size: 11.67px;
            line-height: 150%;
            color: #090C43;
            border: 1px solid #12C44D;
            width: 86px;
            height: 24px;
            background: #8FF6B2;
            border-radius: 24px;

            display: flex;
            flex-direction: row;
            justify-content: center;
            position: absolute;
            right: 25px;
          }
        }
        .accordion-icon {
          height: 8px;
          width: 14px;
          margin: auto;
          padding-right: 15px;
        }
      }
      .accordion-content {
        padding: 20px 0px;
        text-align: left;
      }
    }
  }
</style>
